import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from "@/store";
Vue.use(VueI18n)

export default new VueI18n({
  locale: store.getters['app/config'].appLangue, // set default locale
  fallbackLocale: 'fr', // set default locale
  messages: {
    'en': {
      ...require('@/locales/en/top_bar.json'),
      ...require('@/locales/en/left_bar.json'),
      ...require('@/locales/en/auth.json'),
    },
    'fr': {
      ...require('@/locales/fr/top_bar.json'),
      ...require('@/locales/fr/left_bar.json'),
      ...require('@/locales/fr/auth.json'),
    },
    
  },
  silentTranslationWarn: true
})
